import { TReduxActions } from '../../types/redux';
import { EResidentialComplexesIdsTypes } from '../../actions';

export function residentialComplexesIdsReducer(state: number[] = [], action: TReduxActions) {
  switch (action.type) {
    case EResidentialComplexesIdsTypes.ResidentialComplexesIdsChange:
      return action.payload;

    default:
      return state;
  }
}
